import { AxiosResponse } from "axios";
import { IChartDataSet } from "../../../Contracts/chart/IChartDataSet";
import { pieChartEmployeeHeadCountColour } from "../../../Helpers/Chart/colourHelper";
import { formatCurrencyInputValue } from "../../../Helpers/CurrencyFormatter";
import { formatChartLabel } from "../../../Helpers/Dashboard/dashboardHelper";
import { defaultObject } from "../../../Helpers/typescriptHelper";
import { IDoubleColumnChartData } from "../../Common/Components/Charts/Base/DoubleColumnChart/IDoubleColumnChartData";
import { IPieChartData, IPieChartDataSet } from "../../Common/Components/Charts/Base/PieChart/IPieChartData";
import { IMultiSelectOptions } from "../../Common/Components/MultiSelect/MultiSelect";
import { DashboardColour } from "../../Common/Constants/Colour/dashboardColour";
import { ResultWithValue } from "../../Common/Constants/Result/ResultWithValue";
import { EmploymentEquityDashboardDto } from "../Dto/EmploymentEquity/Dashboard";
import { Gender, OccupationalLevelTypes, RaceTypes, RemunerationType } from "../Enum/BEE123Enums";
import { IComboChartData, IComboChartDataSet } from "../../Common/Components/Charts/Base/ComboChart/IComboChartData";

const getTopManagementSeries = (combinedSeries: EmploymentEquityDashboardDto.EmployeeHeadcountSeriesItem[]) => {
    let helper: { [key: string]: EmploymentEquityDashboardDto.EmployeeHeadcountSeriesItem } = {};
    let result = combinedSeries.reduce(function (r: EmploymentEquityDashboardDto.EmployeeHeadcountSeriesItem[], o: EmploymentEquityDashboardDto.EmployeeHeadcountSeriesItem) {
        var key = o.race + '-' + o.gender;

        if (!helper[key]) {
            helper[key] = Object.assign({}, o); // create a copy of o
            r.push(helper[key]);
        } else {
            helper[key].value += o.value;
        }

        return r;
    }, []);
    return result;
}

export const mapEmployeeHeadcountToDoubleColumnChartData = (SelectedRaceIds: Array<IMultiSelectOptions>, SelectedgenderIds: Array<IMultiSelectOptions>, SelectedOccupationalLevels: Array<IMultiSelectOptions>, isPowerpointPrint: boolean) => (summaryResult: AxiosResponse<EmploymentEquityDashboardDto.EmployeeHeadcountSummary>): ResultWithValue<IDoubleColumnChartData> => {

    if (summaryResult.status !== 200)
        return defaultObject;
    const summary = summaryResult.data.data;
    let filteredArray = summary;
    const CustomTooltipHeadcount = [];

    for (const selectedOccupation of SelectedOccupationalLevels) {
        if (filteredArray.find(x => x.label === selectedOccupation.label) != null)
            continue;
        else if (selectedOccupation.value === OccupationalLevelTypes.Top_Management.toString()) {
            var combinedSeries: EmploymentEquityDashboardDto.EmployeeHeadcountSeriesItem[] = [];
            var executiveDirectorSeries = filteredArray.find(x => x.label === "Executive Director")?.series ?? [];
            var otherExecutiveManagementSeries = filteredArray.find(x => x.label === "Other Executive Management")?.series ?? [];
            combinedSeries = otherExecutiveManagementSeries.concat(executiveDirectorSeries);

            filteredArray.push({
                label: selectedOccupation.label,
                series: getTopManagementSeries(combinedSeries),
                sortOrder: 1
            });
        }
        else {
            filteredArray.push({
                label: selectedOccupation.label,
                series: [],
                sortOrder: + selectedOccupation.value
            });
        }
        filteredArray = filteredArray.filter(item => item.label !== "Executive Director" && item.label !== "Other Executive Management");
    }
    filteredArray = filteredArray.sort((a, b) => (a.sortOrder > b.sortOrder)
        ? 1
        : -1);

    const AfricanMale: IChartDataSet = {
        label: "African-Male",
        data: new Array(filteredArray.length).fill(0),
        backgroundColor: DashboardColour.AfricanMale
    };
    const AfricanFemale: IChartDataSet = {
        label: "African-Female",
        data: new Array(filteredArray.length).fill(0),
        backgroundColor: DashboardColour.AfricanFemale
    };
    const ColouredMale: IChartDataSet = {
        label: "Coloured-Male",
        data: new Array(filteredArray.length).fill(0),
        backgroundColor: DashboardColour.ColouredMale
    };
    const ColouredFemale: IChartDataSet = {
        label: "Coloured-Female",
        data: new Array(filteredArray.length).fill(0),
        backgroundColor: DashboardColour.ColouredFemale
    };
    const IndianMale: IChartDataSet = {
        label: "Indian-Male",
        data: new Array(filteredArray.length).fill(0),
        backgroundColor: DashboardColour.IndianMale
    };
    const IndianFemale: IChartDataSet = {
        label: "Indian-Female",
        data: new Array(filteredArray.length).fill(0),
        backgroundColor: DashboardColour.IndianFemale
    };
    const WhiteMale: IChartDataSet = {
        label: "White-Male",
        data: new Array(filteredArray.length).fill(0),
        backgroundColor: DashboardColour.WhiteMale
    };
    const WhiteFemale: IChartDataSet = {
        label: "White-Female",
        data: new Array(filteredArray.length).fill(0),
        backgroundColor: DashboardColour.WhiteFemale
    };
    const NonRSAMale: IChartDataSet = {
        label: "NonRSA-Male",
        data: new Array(filteredArray.length).fill(0),
        backgroundColor: DashboardColour.NonRSAMale
    };
    const NonRSAFemale: IChartDataSet = {
        label: "NonRSA-Female",
        data: new Array(filteredArray.length).fill(0),
        backgroundColor: DashboardColour.NonRSAFemale
    };

    let TotalHeadcount = 0;
    for (let occupationIndex = 0; occupationIndex < filteredArray.length; occupationIndex++) {
        const headcountsummaryitem = filteredArray[occupationIndex];
        for (const series of headcountsummaryitem.series) {

            if (series.gender === Gender.Male && series.race === RaceTypes.African) {
                AfricanMale.data[occupationIndex] = series.value;
                TotalHeadcount += series.value;
            }
            if (series.gender === Gender.Female && series.race === RaceTypes.African) {
                AfricanFemale.data[occupationIndex] = series.value;
                TotalHeadcount += series.value;
            }

            if (series.gender === Gender.Male && series.race === RaceTypes.Coloured) {
                ColouredMale.data[occupationIndex] = series.value;
                TotalHeadcount += series.value;
            }

            if (series.gender === Gender.Female && series.race === RaceTypes.Coloured) {
                ColouredFemale.data[occupationIndex] = series.value;
                TotalHeadcount += series.value;
            }
            if (series.gender === Gender.Male && series.race === RaceTypes.Indian) {
                IndianMale.data[occupationIndex] = series.value;
                TotalHeadcount += series.value;
            }

            if (series.gender === Gender.Female && series.race === RaceTypes.Indian) {
                IndianFemale.data[occupationIndex] = series.value;
                TotalHeadcount += series.value;
            }

            if (series.gender === Gender.Male && series.race === RaceTypes.White) {
                WhiteMale.data[occupationIndex] = series.value;
                TotalHeadcount += series.value;
            }

            if (series.gender === Gender.Female && series.race === RaceTypes.White) {
                WhiteFemale.data[occupationIndex] = series.value;
                TotalHeadcount += series.value;
            }

            if (series.gender === Gender.Male && series.race === RaceTypes.NonRSA) {
                NonRSAMale.data[occupationIndex] = series.value;
                TotalHeadcount += series.value;
            }

            if (series.gender === Gender.Female && series.race === RaceTypes.NonRSA) {
                NonRSAFemale.data[occupationIndex] = series.value;
                TotalHeadcount += series.value;
            }
        }
        CustomTooltipHeadcount.push(TotalHeadcount);
        TotalHeadcount = 0;

    }

    const SelectedRaceIdList = SelectedRaceIds.map(r => + r.value);
    const SelectedgenderIdList = SelectedgenderIds.map(r => + r.value);
    if (!SelectedRaceIdList.includes(RaceTypes.African)) {
        AfricanMale.data = [];
        AfricanFemale.data = [];
    }
    if (!SelectedRaceIdList.includes(RaceTypes.Coloured)) {
        ColouredFemale.data = [];
        ColouredMale.data = [];
    }
    if (!SelectedRaceIdList.includes(RaceTypes.Indian)) {
        IndianFemale.data = [];
        IndianMale.data = [];
    }
    if (!SelectedRaceIdList.includes(RaceTypes.White)) {
        WhiteFemale.data = [];
        WhiteMale.data = [];
    }
    if (!SelectedRaceIdList.includes(RaceTypes.NonRSA)) {
        NonRSAFemale.data = [];
        NonRSAMale.data = [];
    }

    if (!SelectedgenderIdList.includes(Gender.Male)) {
        AfricanMale.data = [];
        IndianMale.data = [];
        ColouredMale.data = [];
        WhiteMale.data = [];
        NonRSAMale.data = [];
    }

    if (!SelectedgenderIdList.includes(Gender.Female)) {
        AfricanFemale.data = [];
        IndianFemale.data = [];
        ColouredFemale.data = [];
        WhiteFemale.data = [];
        NonRSAFemale.data = [];
    }

    const datasets: Array<IChartDataSet> = [        
        NonRSAMale.data.length > 0
            ? NonRSAMale
            : defaultObject,
        NonRSAFemale.data.length > 0
            ? NonRSAFemale
            : defaultObject,
        AfricanMale.data.length > 0
            ? AfricanMale
            : defaultObject,
        AfricanFemale.data.length > 0
            ? AfricanFemale
            : defaultObject,
        ColouredMale.data.length > 0
            ? ColouredMale
            : defaultObject,
        ColouredFemale.data.length > 0
            ? ColouredFemale
            : defaultObject,
        IndianMale.data.length > 0
            ? IndianMale
            : defaultObject,
        IndianFemale.data.length > 0
            ? IndianFemale
            : defaultObject,
        WhiteMale.data.length > 0
            ? WhiteMale
            : defaultObject,
        WhiteFemale.data.length > 0
            ? WhiteFemale
            : defaultObject
    ].filter(i => i.label != null);

    const finaldatasets: Array<IChartDataSet> = [];
    if (isPowerpointPrint) {
        datasets.forEach(d => {
            finaldatasets.push(d);
            //Annotation if needed 
            var Annotation: IChartDataSet = {
                label: { 'type': 'string', role: 'annotation' },
                data: d.data,
                backgroundColor: d.backgroundColor
            }

            finaldatasets.push(Annotation);
        });
    }

    let hasNonZeroValue = false;

    let dataSetWithoutZeros = JSON.stringify(datasets, (key, value) => {
        if (value > 0) {
            hasNonZeroValue = true;
        }
        return value;
    });
    
    if (hasNonZeroValue) {
        dataSetWithoutZeros = JSON.stringify(datasets, (key, value) => 
            value === 0 ? -1 : value
        );
    }

    return {
        isSuccess: true,
        errorMessage: '',
        value: {
            labels: filteredArray.map((i) => formatChartLabel(i.label, (90 / (summary.length), 10))),
            datasets: isPowerpointPrint ? finaldatasets : JSON.parse(dataSetWithoutZeros)
            // customTooltips: CustomTooltipHeadcount.map((i) => "Total: " + i)
        }
    }
}

export const mapIncomeDifferentialsToDoubleColumnChartData = (
    SelectedRemunerationTypeIds: Array<IMultiSelectOptions>,
    isPowerpointPrint: boolean) => (summaryResult: AxiosResponse<EmploymentEquityDashboardDto.IncomeDifferentialsSummary>): ResultWithValue<IDoubleColumnChartData> => {

        if (summaryResult.status !== 200)
            return defaultObject;
        const summary = summaryResult.data.data;

        let filteredArray = summary;
        const CustomTooltipIncomeDifferentials = [];

        filteredArray = filteredArray.sort((a, b) => (a.sortOrder > b.sortOrder)
            ? 1
            : -1);

        const High: IChartDataSet = {
            label: "High",
            data: new Array(filteredArray.length).fill(0),
            backgroundColor: DashboardColour.High
        };
        const Low: IChartDataSet = {
            label: "Low",
            data: new Array(filteredArray.length).fill(0),
            backgroundColor: DashboardColour.Low
        };
        const Average: IChartDataSet = {
            label: "Average",
            data: new Array(filteredArray.length).fill(0),
            backgroundColor: DashboardColour.Average
        };
        const Median: IChartDataSet = {
            label: "Median",
            data: new Array(filteredArray.length).fill(0),
            backgroundColor: DashboardColour.Median
        };

        let TotalRemuneration = 0;
        for (let raceGenderIndex = 0; raceGenderIndex < filteredArray.length; raceGenderIndex++) {
            const incomeDifferentialssummaryitem = filteredArray[raceGenderIndex];
            for (const series of incomeDifferentialssummaryitem.series) {
                if (series.remunerationType == RemunerationType.High) {
                    High.data[raceGenderIndex] = series.value;
                    TotalRemuneration += series.value;
                }
                if (series.remunerationType == RemunerationType.Low) {
                    Low.data[raceGenderIndex] = series.value;
                    TotalRemuneration += series.value;
                }

                if (series.remunerationType == RemunerationType.Average) {
                    Average.data[raceGenderIndex] = series.value;
                    TotalRemuneration += series.value;
                }

                if (series.remunerationType == RemunerationType.Median) {
                    Median.data[raceGenderIndex] = series.value;
                    TotalRemuneration += series.value;
                }
            }
            CustomTooltipIncomeDifferentials.push(formatCurrencyInputValue(TotalRemuneration));
            TotalRemuneration = 0;

        }
        const SelectedRemunerationTypeIdList = SelectedRemunerationTypeIds.map(r => + r.value);

        let buildDatasets: Array<IChartDataSet> = [];
        if (SelectedRemunerationTypeIdList.includes(1)) {
            buildDatasets.push(High.data.length > 0
                ? High
                : defaultObject);
        }
        if (SelectedRemunerationTypeIdList.includes(2)) {
            buildDatasets.push(Low.data.length > 0
                ? Low
                : defaultObject);
        }
        if (SelectedRemunerationTypeIdList.includes(3)) {
            buildDatasets.push(Average.data.length > 0
                ? Average
                : defaultObject);
        }
        if (SelectedRemunerationTypeIdList.includes(4)) {
            buildDatasets.push(Median.data.length > 0
                ? Median
                : defaultObject);
        }

        const datasets: Array<IChartDataSet> = buildDatasets;

        const finaldatasets: Array<IChartDataSet> = [];
        if (isPowerpointPrint) {
            datasets.forEach(d => {
                finaldatasets.push(d);
                //Annotation if needed 
                var Annotation: IChartDataSet = {
                    label: { 'type': 'string', role: 'annotation' },
                    data: d.data,
                    backgroundColor: d.backgroundColor
                }

                finaldatasets.push(Annotation);
            });
        }
        return {
            isSuccess: true,
            errorMessage: '',
            value: {
                labels: filteredArray.map((i) => formatChartLabel(i.label, (90 / (summary.length), 10))),
                datasets: isPowerpointPrint ? finaldatasets : datasets
                // customTooltips: CustomTooltipIncomeDifferentials.map((i) => "Total: " + i)
            }
        }
    }


export const mapEmployeeHeadcountToPieChartData = (selectedOccupationalId: number, isPowerpointPrint?: boolean) => (summaryResult: AxiosResponse<EmploymentEquityDashboardDto.EmployeeHeadcountSummary>): ResultWithValue<IPieChartData> => {
    if (summaryResult.status !== 200)
        return defaultObject;
    const summary = summaryResult.data.data;

    const filteredArray = summary;
    let dataset: Array<IPieChartDataSet> = [];
    const labelArray: Array<string> = ['Race-Gender', 'Headcount'];

    if (selectedOccupationalId === 0) {

        for (const item of filteredArray) {
            let s = item.series;
            for (const seriesI of s) {
                const label = `${RaceTypes[seriesI.race]}-${Gender[seriesI.gender]}`;
                const result = dataset.filter(obj => {
                    return obj.label === label
                })
                if (result[0]) {
                    result[0].value = result[0].value + seriesI.value;
                } else {
                    dataset.push({
                        label,
                        value: seriesI.value,
                        backgroundColor: pieChartEmployeeHeadCountColour(seriesI.race, seriesI.gender),
                        sortOrder: seriesI.race
                    })
                }
            }
        }
    } else if (selectedOccupationalId === OccupationalLevelTypes.Top_Management) {
        var combinedSeries: EmploymentEquityDashboardDto.EmployeeHeadcountSeriesItem[] = [];
        var executiveDirectorSeries = filteredArray.find(x => x.label === "Executive Director")?.series ?? [];
        var otherExecutiveManagementSeries = filteredArray.find(x => x.label === "Other Executive Management")?.series ?? [];
        combinedSeries = otherExecutiveManagementSeries.concat(executiveDirectorSeries);
        combinedSeries = getTopManagementSeries(combinedSeries);

        for (const seriesItem of combinedSeries) {
            const label = `${RaceTypes[seriesItem.race]}-${Gender[seriesItem.gender]}`;

            dataset.push({
                label,
                value: seriesItem.value,
                backgroundColor: pieChartEmployeeHeadCountColour(seriesItem.race, seriesItem.gender),
                sortOrder: seriesItem.race
            })
        }
    }

    else {
        for (const item of filteredArray) {
            for (const seriesItem of item.series) {
                const label = `${RaceTypes[seriesItem.race]}-${Gender[seriesItem.gender]}`;

                dataset.push({
                    label,
                    value: seriesItem.value,
                    backgroundColor: pieChartEmployeeHeadCountColour(seriesItem.race, seriesItem.gender),
                    sortOrder: seriesItem.race
                })
            }
        }
    }

    dataset = dataset.sort((a, b) => (a.sortOrder && b.sortOrder
        ? a.sortOrder > b.sortOrder
        : dataset)
        ? 1
        : -1);

    var finalDataset: Array<IPieChartDataSet> = [];
    if (isPowerpointPrint) {
        dataset.forEach(d => {
            finalDataset.push(
                {
                    label: d.label + ' (' + d.value + ')',
                    backgroundColor: d.backgroundColor,
                    value: d.value
                }
            );
        });
    }

    return {
        isSuccess: true,
        errorMessage: '',
        value: {
            labels: labelArray,
            datasets: isPowerpointPrint ? finalDataset : dataset
        }
    }
}

export const mapMovementHeadcountToDoubleColumnChartData = (SelectedRaceIds: Array<IMultiSelectOptions>, SelectedgenderIds: Array<IMultiSelectOptions>, SelectedOccupationalLevels: Array<IMultiSelectOptions>, isPowerpointPrint: boolean) => (summaryResult: AxiosResponse<EmploymentEquityDashboardDto.EmployeeHeadcountSummary>): ResultWithValue<IDoubleColumnChartData> => {

    if (summaryResult.status !== 200)
        return defaultObject;
    const summary = summaryResult.data.data;

    let filteredArray = summary;
    const CustomTooltipHeadcount = [];

    for (const selectedOccupation of SelectedOccupationalLevels) {
        if (filteredArray.find(x => x.label === selectedOccupation.label) != null)
            continue;
        else if (selectedOccupation.value === OccupationalLevelTypes.Top_Management.toString()) {
            let combinedSeries: EmploymentEquityDashboardDto.EmployeeHeadcountSeriesItem[] = [];
            const executiveDirector = filteredArray.find(x => x.label === "Executive Director");
            const executiveDirectorSeries = executiveDirector?.series ?? [];
            const otherExecutiveManagement = filteredArray.find(x => x.label === "Other Executive Management");
            const otherExecutiveManagementSeries = otherExecutiveManagement?.series ?? [];
            combinedSeries = otherExecutiveManagementSeries.concat(executiveDirectorSeries);
            const totalPercentage = (executiveDirector?.totalEmployeeHeadcountPercentage ?? 0) + (otherExecutiveManagement?.totalEmployeeHeadcountPercentage ?? 0);

            filteredArray.push({
                label: selectedOccupation.label,
                series: getTopManagementSeries(combinedSeries),
                sortOrder: 1,
                totalEmployeeHeadcountPercentage: totalPercentage,
            });
        }
        else {
            filteredArray.push({
                label: selectedOccupation.label,
                series: [],
                sortOrder: + selectedOccupation.value,
                totalEmployeeHeadcountPercentage: 0
            });
        }
    }

    filteredArray = filteredArray.filter(item => item.label !== "Executive Director" && item.label !== "Other Executive Management");
    filteredArray = filteredArray.sort((a, b) => (a.sortOrder > b.sortOrder)
        ? 1
        : -1);

    const AfricanMale: IChartDataSet = {
        label: "African-Male",
        data: new Array(filteredArray.length).fill(0),
        backgroundColor: DashboardColour.AfricanMale
    };
    const AfricanFemale: IChartDataSet = {
        label: "African-Female",
        data: new Array(filteredArray.length).fill(0),
        backgroundColor: DashboardColour.AfricanFemale
    };
    const ColouredMale: IChartDataSet = {
        label: "Coloured-Male",
        data: new Array(filteredArray.length).fill(0),
        backgroundColor: DashboardColour.ColouredMale
    };
    const ColouredFemale: IChartDataSet = {
        label: "Coloured-Female",
        data: new Array(filteredArray.length).fill(0),
        backgroundColor: DashboardColour.ColouredFemale
    };
    const IndianMale: IChartDataSet = {
        label: "Indian-Male",
        data: new Array(filteredArray.length).fill(0),
        backgroundColor: DashboardColour.IndianMale
    };
    const IndianFemale: IChartDataSet = {
        label: "Indian-Female",
        data: new Array(filteredArray.length).fill(0),
        backgroundColor: DashboardColour.IndianFemale
    };
    const WhiteMale: IChartDataSet = {
        label: "White-Male",
        data: new Array(filteredArray.length).fill(0),
        backgroundColor: DashboardColour.WhiteMale
    };
    const WhiteFemale: IChartDataSet = {
        label: "White-Female",
        data: new Array(filteredArray.length).fill(0),
        backgroundColor: DashboardColour.WhiteFemale
    };
    const NonRSAMale: IChartDataSet = {
        label: "NonRSA-Male",
        data: new Array(filteredArray.length).fill(0),
        backgroundColor: DashboardColour.NonRSAMale
    };
    const NonRSAFemale: IChartDataSet = {
        label: "NonRSA-Female",
        data: new Array(filteredArray.length).fill(0),
        backgroundColor: DashboardColour.NonRSAFemale
    };

    let TotalHeadcount = 0.0;
    for (let occupationIndex = 0; occupationIndex < filteredArray.length; occupationIndex++) {
        const headcountsummaryitem = filteredArray[occupationIndex];
        for (const series of headcountsummaryitem.series) {
            if (series.gender === Gender.Male && series.race === RaceTypes.African) {
                AfricanMale.data[occupationIndex] = series.value;
                TotalHeadcount += series.value;
            }
            if (series.gender === Gender.Female && series.race === RaceTypes.African) {
                AfricanFemale.data[occupationIndex] = series.value;
                TotalHeadcount += series.value;
            }

            if (series.gender === Gender.Male && series.race === RaceTypes.Coloured) {
                ColouredMale.data[occupationIndex] = series.value;
                TotalHeadcount += series.value;
            }

            if (series.gender === Gender.Female && series.race === RaceTypes.Coloured) {
                ColouredFemale.data[occupationIndex] = series.value;
                TotalHeadcount += series.value;
            }
            if (series.gender === Gender.Male && series.race === RaceTypes.Indian) {
                IndianMale.data[occupationIndex] = series.value;
                TotalHeadcount += series.value;
            }

            if (series.gender === Gender.Female && series.race === RaceTypes.Indian) {
                IndianFemale.data[occupationIndex] = series.value;
                TotalHeadcount += series.value;
            }

            if (series.gender === Gender.Male && series.race === RaceTypes.White) {
                WhiteMale.data[occupationIndex] = series.value;
                TotalHeadcount += series.value;
            }

            if (series.gender === Gender.Female && series.race === RaceTypes.White) {
                WhiteFemale.data[occupationIndex] = series.value;
                TotalHeadcount += series.value;
            }

            if (series.gender === Gender.Male && series.race === RaceTypes.NonRSA) {
                NonRSAMale.data[occupationIndex] = series.value;
                TotalHeadcount += series.value;
            }

            if (series.gender === Gender.Female && series.race === RaceTypes.NonRSA) {
                NonRSAFemale.data[occupationIndex] = series.value;
                TotalHeadcount += series.value;
            }
        }
        CustomTooltipHeadcount.push(headcountsummaryitem.totalEmployeeHeadcountPercentage);
        TotalHeadcount = 0;
    }

    const SelectedRaceIdList = SelectedRaceIds.map(r => + r.value);
    const SelectedgenderIdList = SelectedgenderIds.map(r => + r.value);
    if (!SelectedRaceIdList.includes(RaceTypes.African)) {
        AfricanMale.data = [];
        AfricanFemale.data = [];
    }
    if (!SelectedRaceIdList.includes(RaceTypes.Coloured)) {
        ColouredFemale.data = [];
        ColouredMale.data = [];
    }
    if (!SelectedRaceIdList.includes(RaceTypes.Indian)) {
        IndianFemale.data = [];
        IndianMale.data = [];
    }
    if (!SelectedRaceIdList.includes(RaceTypes.White)) {
        WhiteFemale.data = [];
        WhiteMale.data = [];
    }
    if (!SelectedRaceIdList.includes(RaceTypes.NonRSA)) {
        NonRSAFemale.data = [];
        NonRSAMale.data = [];
    }

    if (!SelectedgenderIdList.includes(Gender.Male)) {
        AfricanMale.data = [];
        IndianMale.data = [];
        ColouredMale.data = [];
        WhiteMale.data = [];
        NonRSAMale.data = [];
    }

    if (!SelectedgenderIdList.includes(Gender.Female)) {
        AfricanFemale.data = [];
        IndianFemale.data = [];
        ColouredFemale.data = [];
        WhiteFemale.data = [];
        NonRSAFemale.data = [];
    }

    const datasets: Array<IChartDataSet> = [
        AfricanMale.data.length > 0
            ? AfricanMale
            : defaultObject,
        AfricanFemale.data.length > 0
            ? AfricanFemale
            : defaultObject,
        ColouredMale.data.length > 0
            ? ColouredMale
            : defaultObject,
        ColouredFemale.data.length > 0
            ? ColouredFemale
            : defaultObject,
        IndianMale.data.length > 0
            ? IndianMale
            : defaultObject,
        IndianFemale.data.length > 0
            ? IndianFemale
            : defaultObject,
        WhiteMale.data.length > 0
            ? WhiteMale
            : defaultObject,
        WhiteFemale.data.length > 0
            ? WhiteFemale
            : defaultObject,
        NonRSAMale.data.length > 0
            ? NonRSAMale
            : defaultObject,
        NonRSAFemale.data.length > 0
            ? NonRSAFemale
            : defaultObject
    ].filter(i => i.label != null);

    const finaldatasets: Array<IChartDataSet> = [];
    if (isPowerpointPrint) {
        datasets.forEach(d => {
            finaldatasets.push(d);
            //Annotation if needed 
            var Annotation: IChartDataSet = {
                label: { 'type': 'string', role: 'annotation' },
                data: d.data,
                backgroundColor: d.backgroundColor
            }

            finaldatasets.push(Annotation);
        });
    }
    return {
        isSuccess: true,
        errorMessage: '',
        value: {
            labels: filteredArray.map((i) => formatChartLabel(i.label, (90 / (summary.length), 10))),
            datasets: isPowerpointPrint ? finaldatasets : datasets,
            customTooltips: CustomTooltipHeadcount.map((i) => "Percentage: " + i?.toFixed(2) + "%")
        }
    }
}

export const mapEmployeeHeadcountToComboChartData = (
    eePlanTracking: AxiosResponse<EmploymentEquityDashboardDto.EEPlan5YearTrackingDtoOut>
): ResultWithValue<IComboChartData> => {
    const response = eePlanTracking.data;

    const headcountData = response.actualHeadcountPerMonth || [];
    const projectionHeadcountData = response.projectionHeadcountPerMonth || [];
    const targetHeadcountsData = response.targetHeadcounts;

    const labels = headcountData.map(item => item.month);

    const actualHeadcounts = headcountData.map(item => item.headcount);
    const projectionHeadcounts = projectionHeadcountData.map(item => item.headcount);

    let targetHeadcounts: (number | null)[] = [];

    if (targetHeadcountsData && targetHeadcountsData.length > 0) {
        targetHeadcounts = targetHeadcountsData.map(item => item.headcount);
    } else if (response.targetHeadcount !== null && headcountData.length > 0) {
        targetHeadcounts = headcountData.map(() => response.targetHeadcount);
    }

    const mappedTargetHeadcounts = targetHeadcounts.map(hc => hc ?? 0);

    const actualDataset: IComboChartDataSet = {
        label: "Actual Headcount",
        data: actualHeadcounts,
        backgroundColor: actualHeadcounts.map(() => "#4285F4"),
    };

    const projectedDataset: IComboChartDataSet = {
        label: "Projection",
        data: projectionHeadcounts,
        backgroundColor: [],
    };

    const targetDataset: IComboChartDataSet = {
        label: "Target Headcount",
        data: mappedTargetHeadcounts,
        backgroundColor: mappedTargetHeadcounts.map(() => "#FBBC05"),
    };

    return {
        isSuccess: true,
        errorMessage: "",
        value: {
            labels,
            datasets: [actualDataset, targetDataset, projectedDataset],
            valueFormatter: (value: string) => {
                const num = parseFloat(value);
                return isNaN(num) ? value : num.toFixed(2);
            },
            customTooltips: headcountData.map(item => `Month: ${item.month}, Headcount: ${item.headcount}`),
        },
    };
};